import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CollegeList from './containers/list';
import Errors from './containers/errors';

const CollegeDatabase = ({ location }) => {
  const tabs = ['/colleges', '/colleges/errors'];
  return (
    <div>
      <Box marginBottom={3}>
        <Tabs
          value={location.pathname}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab
            value={tabs[0]}
            label="Colleges"
            component={Link}
            to={tabs[0]}
          />
          <Tab value={tabs[1]} label="Errors" component={Link} to={tabs[1]} />
        </Tabs>
      </Box>
      <Switch>
        <Route exact path={tabs[0]} component={CollegeList} />
        <Route exact path={tabs[1]} component={Errors} />
      </Switch>
    </div>
  )
}

export default CollegeDatabase;